import axios from 'axios'

const state = {
    cloud_host: {},
    networks: {},
    elastic_ips: {},
    nat_gateways: {},
    routers: {},
    firewalls: {},
    firewall: {},
    cloud_hosts: {},
    disks: {},
    vpcs: {},
    private_networks: {},
    vpc: {},
    cloud_host_errors: {},
    load_balancers: {},
    load_balancer: {},
    listeners: {},
    real_server_groups: {},
    cloud_host_loading: false,
    ips_policies: {},
    antivirus_policies: {},
    object_groups: {},
    snapshots: {},
    nics: {},
    key_pairs: {},
    object_storage_containers: {},
    object_storage_container: {},
    object_storage_container_objects: {},
    key_pair: {},
}

const getters = {
    cloud_host: state => state.cloud_host,
    networks: state => state.networks,
    elastic_ips: state => state.elastic_ips,
    key_pairs: state => state.key_pairs,
    nat_gateways: state => state.nat_gateways,
    routers: state => state.routers,
    firewalls: state => state.firewalls,
    firewall: state => state.firewall,
    cloud_hosts: state => state.cloud_hosts,
    disks: state => state.disks,
    vpcs: state => state.vpcs,
    load_balancers: state => state.load_balancers,
    private_networks: state => state.private_networks,
    vpc: state => state.vpc,
    cloud_host_errors: state => state.cloud_host_errors,
    cloud_host_loading: state => state.cloud_host_loading,
    ips_policies: state => state.ips_policies,
    antivirus_policies: state => state.antivirus_policies,
    load_balancer: state => state.load_balancer,
    listeners: state => state.listeners,
    real_server_groups: state => state.real_server_groups,
    object_groups: state => state.object_groups,
    snapshots: state => state.snapshots,
    nics: state => state.nics,
    key_pair: state => state.key_pair,
    object_storage_containers: state => state.object_storage_containers,
    object_storage_container: state => state.object_storage_container,
    object_storage_container_objects: state => state.object_storage_container_objects,
}

const mutations = {
    setCloudHost(state, cloud_host) {
        state.cloud_host = cloud_host
    },
    setCloudHosts(state, cloud_hosts) {
        state.cloud_hosts = cloud_hosts
    },
    setNetworks(state, networks) {
        state.networks = networks
    },
    setKeyPairs(state, key_pairs) {
        state.key_pairs = key_pairs
    },
    setVpc(state, vpc) {
        state.vpc = vpc
    },
    setElasticIps(state, elastic_ips) {
        state.elastic_ips = elastic_ips
    },
    setNatGateways(state, nat_gateways) {
        state.nat_gateways = nat_gateways
    },
    setLoadBalancers(state, load_balancers) {
        state.load_balancers = load_balancers
    },
    setLoadBalancer(state, load_balancer) {
        state.load_balancer = load_balancer
    },
    setListeners(state, listeners) {
        state.listeners = listeners
    },
    setRealServerGroups(state, real_server_groups) {
        state.real_server_groups = real_server_groups
    },
    setRouters(state, routers) {
        state.routers = routers
    },
    setFirewalls(state, firewalls) {
        state.firewalls = firewalls
    },
    setFirewall(state, firewall) {
        state.firewall = firewall
    },
    setVpcs(state, vpcs) {
        state.vpcs = vpcs
    },
    setIpsPolicies(state, ips_policies) {
        state.ips_policies = ips_policies
    },
    setAntivirusPolicies(state, antivirus_policies) {
        state.antivirus_policies = antivirus_policies
    },
    setObjectGroups(state, object_groups) {
        state.object_groups = object_groups
    },
    setDisks(state, disks) {
        state.disks = disks
    },
    setSnapshots(state, snapshots) {
        state.snapshots = snapshots
    },
    setNics(state, nics) {
        state.nics = nics
    },
    setCloudHostErrors(state, cloud_host_errors) {
        state.cloud_host_errors = cloud_host_errors
    },
    setCloudHostLoading(state, cloud_host_loading) {
        state.cloud_host_loading = cloud_host_loading
    },
    setKeyPair(state, key_pair) {
        state.key_pair = key_pair
    },
    setObjectStorageContainers(state, object_storage_containers) {
        state.object_storage_containers = object_storage_containers
    },
    setObjectStorageContainer(state, object_storage_container) {
        state.object_storage_container = object_storage_container
    },
    setObjectStorageContainerObjects(state, object_storage_container_objects) {
        state.object_storage_container_objects = object_storage_container_objects
    },
}

const actions = {
    async storeCloudHost({commit}, data) {
        commit('setCloudHostLoading', true)
        commit('setCloudHostErrors', {})
        try {
            let response = await axios.post(`/api/cloud_hosts/store`, data)
            commit('setCloudHostLoading', false)
            commit('setCloudHostErrors', {})
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCloudHostLoading', false)
            commit('setCloudHostErrors', error.response.data.errors)
            return false
        }
    },
    async getCloudHosts({commit}, project_id) {
        try {
            let response = await axios.get(`/api/cloud-hosts/${project_id}`)
            commit('setCloudHosts', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAllCloudHosts({commit}, project_id) {
        try {
            let response = await axios.get(`/api/cloud-hosts/${project_id}/all`)
            commit('setCloudHosts', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getObjectStorageContainers({commit}, {project_id}) {
        commit('setCloudHostLoading', true)
        try {
            let response = await axios.get(`/api/object-storage/${project_id}/containers`)
            commit('setObjectStorageContainers', response.data)
            commit('setCloudHostLoading', false)
            return response.data.ok
        } catch (error) {
            commit('setCloudHostLoading', false)
            console.log(error);
            return false
        }
    },
    async getObjectStorageContainer({commit}, params) {
        commit('setCloudHostLoading', true)

        try {
            let response = await axios.get(`/api/object-storage/${params.project_id}/containers/${params.id}/show`, {params})
            commit('setObjectStorageContainer', response.data.data)
            commit('setCloudHostLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCloudHostLoading', false)
            return false
        }
    },
    async getObjectStorageContainerObjects({commit}, params) {
        commit('setCloudHostLoading', true)
        try {
            let response = await axios.get(`/api/object-storage/${params.project_id}/containers/${params.id}/objects`, {params})
            commit('setObjectStorageContainerObjects', response.data.data)
            commit('setCloudHostLoading', false)
            return response.data.ok
        } catch (error) {
            console.log(error);
            commit('setCloudHostLoading', false)
            return false
        }
    },
    async getKeyPair({commit}, {project_id, id}) {
        try {
            let response = await axios.get(`/api/key-pairs/${project_id}/${id}/show`)
            commit('setKeyPair', response.data.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getIpsPolicies({commit}, {project_id}) {
        try {
            let response = await axios.get(`/api/ips-policies/${project_id}`)
            commit('setIpsPolicies', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getKeyPairs({commit}, {project_id}) {
        try {
            let response = await axios.get(`/api/key-pairs/${project_id}`)
            commit('setKeyPairs', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAllKeyPairs({commit}, {project_id}) {
        try {
            let response = await axios.get(`/api/key-pairs/${project_id}/all`)
            commit('setKeyPairs', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAntivirusPolicies({commit}, {project_id}) {
        try {
            let response = await axios.get(`/api/antivirus-policies/${project_id}`)
            commit('setAntivirusPolicies', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getObjectGroups({commit}, {project_id}) {
        try {
            let response = await axios.get(`/api/object-groups/${project_id}`)
            commit('setObjectGroups', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getVps({commit}, project_id) {
        try {
            let response = await axios.get(`/api/cloud-hosts/${project_id}/vps`)
            commit('setCloudHosts', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getDisks({commit}, project_id) {
        try {
            let response = await axios.get(`/api/disks/${project_id}`)
            commit('setDisks', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getNetworks({commit}, params) {
        try {
            let response = await axios.get(`/api/networks/${params.project_id}`, {params})
            commit('setNetworks', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAllNetworks({commit}, params) {
        try {
            let response = await axios.get(`/api/networks/${params.project_id}/all`, {params})
            commit('setNetworks', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getLoadBalancers({commit}, params) {
        commit('setCloudHostLoading', true)

        try {
            let response = await axios.get(`/api/load-balancers/${params.project_id}`, {params})
            commit('setLoadBalancers', response.data)
            commit('setCloudHostLoading', false)
            return response.data.ok
        } catch (error) {
            commit('setCloudHostLoading', false)
            console.log(error);
            return false
        }
    },
    async getRealServerGroups({commit}, params) {
        commit('setCloudHostLoading', true)

        try {
            let response = await axios.get(`/api/load-balancers/${params.project_id}/${params.id}/real-server-groups`, {params})
            commit('setRealServerGroups', response.data)
            commit('setCloudHostLoading', false)
            return response.data.ok
        } catch (error) {
            commit('setCloudHostLoading', false)
            console.log(error);
            return false
        }
    },
    async getLoadBalancer({commit}, params) {
        try {
            let response = await axios.get(`/api/load-balancers/${params.project_id}/${params.id}/show`, {params})
            commit('setLoadBalancer', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getListeners({commit}, params) {
        try {
            let response = await axios.get(`/api/load-balancers/${params.project_id}/${params.id}/listeners`, {params})
            commit('setListeners', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getSnapshots({commit}, params) {
        try {
            let response = await axios.get(`/api/cloud-hosts/${params.project_id}/${params.id}/snapshots`, {params})
            commit('setSnapshots', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getNics({commit}, params) {
        try {
            let response = await axios.get(`/api/cloud-hosts/${params.project_id}/${params.id}/nics`, {params})
            commit('setNics', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAllNics({commit}, params) {
        try {
            let response = await axios.get(`/api/nics/${params.project_id}`, {params})
            commit('setNics', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getVpcs({commit}, params) {
        try {
            let response = await axios.get(`/api/vpcs/${params.project_id}`, {params})
            commit('setVpcs', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getFirewalls({commit}, params) {
        try {
            let response = await axios.get(`/api/firewalls/${params.project_id}`, {params})
            commit('setFirewalls', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getAllFirewalls({commit}, params) {
        try {
            let response = await axios.get(`/api/firewalls/${params.project_id}/all`, {params})
            commit('setFirewalls', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getFirewall({commit}, params) {
        try {
            let response = await axios.get(`/api/firewalls/${params.project_id}/${params.id}/show`,)
            commit('setFirewall', response.data.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getVpc({commit}, params) {
        try {
            let response = await axios.get(`/api/vpcs/${params.project_id}/${params.id}/show`,)
            commit('setVpc', response.data.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getRouters({commit}, params) {
        try {
            let response = await axios.get(`/api/routers/${params.project_id}`, {params})
            commit('setRouters', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getElasticIps({commit}, params) {
        try {
            let response = await axios.get(`/api/elastic-ips/${params.project_id}`, {params})
            commit('setElasticIps', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getNatGateways({commit}, params) {
        try {
            let response = await axios.get(`/api/nat-gateways/${params.project_id}`, {params})
            commit('setNatGateways', response.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async getCloudHost({commit}, id) {
        try {
            let response = await axios.get(`/api/cloud_hosts/${id}/show`)
            commit('setCloudHost', response.data?.data)
            return response.data.ok
        } catch (error) {
            console.log(error);
            return false
        }
    },
    async updateCloudHost({commit}, data) {
        commit('setCloudHostLoading', true)
        commit('setCloudHostErrors', {})
        try {
            let response = await axios.put(`/api/cloud_hosts/${data.id}/update`, data)
            commit('setCloudHostLoading', false)
            commit('setCloudHostErrors', {})
            return response.data
        } catch (error) {
            console.log(error);
            commit('setCloudHostLoading', false)
            commit('setCloudHostErrors', error.response.data.errors)
            return false
        }
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}